import { inject } from '@angular/core';
import { Routes, Router } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { connectivityGuard } from './core/guards/connectivity.guard';
import { roleGuard } from './core/guards/role.guard';
import { AuthService } from './core/services/auth.service';

export const routes: Routes = [
  // ── Public ──────────────────────────────────────────────────
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then((m) => m.LoginComponent),
    canActivate: [connectivityGuard],
  },
  {
    path: 'register/member',
    loadComponent: () => import('./pages/auth/referral-register/referral-register.component').then((m) => m.ReferralRegisterComponent),
    canActivate: [connectivityGuard],
  },
  {
    path: 'r/:code',
    loadComponent: () => import('./pages/auth/shortlink-redirect/shortlink-redirect.component').then((m) => m.ShortlinkRedirectComponent),
    canActivate: [connectivityGuard],
  },

  // ── Authenticated Layout ──────────────────────────────────
  {
    path: '',
    loadComponent: () => import('./shared/components/layout/layout.component').then((m) => m.LayoutComponent),
    canActivate: [authGuard, connectivityGuard],
    canActivateChild: [connectivityGuard],
    children: [
      {
        path: 'admin',
        canActivate: [roleGuard('admin')],
        loadChildren: () => import('./pages/admin/admin.routes').then((m) => m.adminRoutes),
      },
      {
        path: 'master',
        canActivate: [roleGuard('master')],
        loadChildren: () => import('./pages/dashboard/master.routes').then((m) => m.masterRoutes),
      },
      {
        path: 'member',
        canActivate: [roleGuard('member')],
        loadChildren: () => import('./pages/dashboard/member.routes').then((m) => m.memberRoutes),
      },
      {
        path: 'support',
        canActivate: [roleGuard('support')],
        loadChildren: () => import('./pages/support/support.routes').then((m) => m.supportRoutes),
      },
      {
        path: 'shop',
        canActivate: [roleGuard('shop')],
        loadChildren: () => import('./pages/shop/shop.routes').then((m) => m.shopRoutes),
      },

      // Default redirect based on role
      { 
        path: '', 
        pathMatch: 'full',
        loadComponent: () => import('./pages/auth/login/login.component').then((m) => m.LoginComponent),
        canActivate: [() => {
          const auth = inject(AuthService);
          const router = inject(Router);
          const role = auth.currentUser?.role;
          if (role === 'admin') return router.parseUrl('/admin');
          if (role === 'master') return router.parseUrl('/master');
          if (role === 'member') return router.parseUrl('/member');
          if (role === 'support') return router.parseUrl('/support');
          if (role === 'shop') return router.parseUrl('/shop');
          return router.parseUrl('/login');
        }],
      },
    ],
  },

  // Wildcard
  { path: '**', redirectTo: '/login' },
];
